export const isUUID = <T extends string = string>(str: string): str is T => {
  if (!str || typeof str !== 'string') return false
  const regex =
    /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
  return Boolean(regex.test(str))
}
